import { useState, useEffect } from "react";
 
const SUPABASE_URL = "https://zhfycowmhdhzfmhyrzfl.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJJUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpoZnljb3dtaGRoemZtaHlyemZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2NzI0NzcsImV4cCI6MjA2MzI0ODQ3N30.FfbHfBzDEsIsInJlZiI6InpoZnljb3dtaGRoemZtaHlyemZsIn0";
 
const C = {
  bg: "#faf8f5",
  white: "#ffffff",
  primary: "#e85d26",
  primaryLight: "#fff3ee",
  text: "#1a1a1a",
  textMuted: "#888",
  border: "#f0ebe3",
  success: "#27a060",
  warning: "#f59e0b",
};
 
async function supabaseLogin(email, password) {
  const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "apikey": SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
}
 
async function getCandidatos(token) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/candidatos?select=*&order=created_at.desc`, {
    headers: {
      "apikey": SUPABASE_ANON_KEY,
      "Authorization": `Bearer ${token}`,
    },
  });
  return res.json();
}
 
function ScoreBadge({ score }) {
  const color = score >= 80 ? C.success : score >= 60 ? C.warning : C.primary;
  const nivel = score >= 80 ? "Excelente" : score >= 60 ? "Bueno" : "En desarrollo";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <div style={{
        width: 36, height: 36, borderRadius: "50%",
        background: `conic-gradient(${color} ${score * 3.6}deg, ${C.border} 0deg)`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <div style={{ width: 26, height: 26, borderRadius: "50%", background: C.white, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: 9, fontWeight: 900, color }}>{score}%</span>
        </div>
      </div>
      <span style={{ fontSize: 12, color, fontWeight: 700 }}>{nivel}</span>
    </div>
  );
}
 
function PerfilModal({ candidato, onClose }) {
  if (!candidato) return null;
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 200, padding: 16,
    }} onClick={onClose}>
      <div style={{
        background: C.white, borderRadius: 20, padding: 24, width: "100%",
        maxWidth: 480, maxHeight: "85vh", overflowY: "auto",
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div>
            <div style={{ fontWeight: 900, fontSize: 18, color: C.text }}>{candidato.nombre}</div>
            <div style={{ color: C.textMuted, fontSize: 13 }}>{candidato.email}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: C.textMuted }}>×</button>
        </div>
 
        <ScoreBadge score={candidato.score} />
 
        {candidato.telefono && (
          <div style={{ marginTop: 12, color: "#555", fontSize: 13 }}>📞 {candidato.telefono}</div>
        )}
 
        <div style={{ marginTop: 6, color: "#555", fontSize: 12 }}>
          📅 {new Date(candidato.created_at).toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" })}
        </div>
 
        <div style={{ marginTop: 6 }}>
          <span style={{
            background: candidato.autoriza_contacto ? "#f0fdf4" : "#fef2f2",
            color: candidato.autoriza_contacto ? C.success : "#ef4444",
            fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20,
          }}>
            {candidato.autoriza_contacto ? "✅ Autoriza contacto" : "❌ No autoriza contacto"}
          </span>
        </div>
 
        {candidato.perfil_laboral && (
          <div style={{ marginTop: 16, background: C.primaryLight, borderRadius: 12, padding: "12px 14px" }}>
            <div style={{ color: C.primary, fontSize: 12, fontWeight: 700, marginBottom: 6 }}>👤 Perfil laboral</div>
            <div style={{ color: "#555", fontSize: 13, lineHeight: 1.6 }}>{candidato.perfil_laboral}</div>
          </div>
        )}
 
        {candidato.cargos?.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div style={{ color: C.primary, fontSize: 12, fontWeight: 700, marginBottom: 8 }}>💼 Cargos compatibles</div>
            {candidato.cargos.map((c, i) => (
              <div key={i} style={{ background: C.primaryLight, borderRadius: 8, padding: "8px 12px", marginBottom: 6, color: "#555", fontSize: 13 }}>✅ {c}</div>
            ))}
          </div>
        )}
 
        {candidato.fortalezas?.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div style={{ color: C.success, fontSize: 12, fontWeight: 700, marginBottom: 8 }}>💪 Fortalezas</div>
            {candidato.fortalezas.map((f, i) => (
              <div key={i} style={{ color: "#555", fontSize: 13, marginBottom: 4 }}>• {f}</div>
            ))}
          </div>
        )}
 
        <button onClick={onClose} style={{
          marginTop: 20, width: "100%", background: C.primary, border: "none",
          borderRadius: 12, padding: "13px", color: "#fff", fontWeight: 700,
          fontSize: 14, cursor: "pointer",
        }}>Cerrar</button>
      </div>
    </div>
  );
}
 
export default function AdminPanel() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [candidatos, setCandidatos] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [selected, setSelected] = useState(null);
  const [busqueda, setBusqueda] = useState("");
 
  async function handleLogin() {
    if (!email.trim() || !password.trim()) return;
    setLoading(true); setError("");
    const data = await supabaseLogin(email, password);
    if (data.access_token) {
      setToken(data.access_token);
    } else {
      setError("Email o contraseña incorrectos");
    }
    setLoading(false);
  }
 
  useEffect(() => {
    if (!token) return;
    setLoadingData(true);
    getCandidatos(token).then(data => {
      if (Array.isArray(data)) setCandidatos(data);
      setLoadingData(false);
    });
  }, [token]);
 
  const filtrados = candidatos.filter(c =>
    c.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.email?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.nivel?.toLowerCase().includes(busqueda.toLowerCase())
  );
 
  // LOGIN
  if (!token) return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Segoe UI', sans-serif", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 18, margin: "0 auto 12px" }}>JB</div>
          <div style={{ fontWeight: 900, fontSize: 22, color: C.text }}>Panel Admin</div>
          <div style={{ color: C.textMuted, fontSize: 13, marginTop: 4 }}>Acceso exclusivo</div>
        </div>
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 20, padding: 24 }}>
          <input
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email"
            type="email"
            style={{ width: "100%", background: C.bg, border: `1px solid ${C.border}`, borderRadius: 10, padding: "11px 14px", color: C.text, fontSize: 14, outline: "none", fontFamily: "inherit", boxSizing: "border-box", marginBottom: 10 }}
          />
          <input
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleLogin()}
            placeholder="Contraseña"
            type="password"
            style={{ width: "100%", background: C.bg, border: `1px solid ${C.border}`, borderRadius: 10, padding: "11px 14px", color: C.text, fontSize: 14, outline: "none", fontFamily: "inherit", boxSizing: "border-box", marginBottom: 12 }}
          />
          {error && <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 10, textAlign: "center" }}>{error}</div>}
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{ width: "100%", background: C.primary, border: "none", borderRadius: 12, padding: "13px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", boxShadow: "0 6px 20px rgba(232,93,38,0.3)", fontFamily: "inherit" }}
          >
            {loading ? "⏳ Ingresando..." : "Ingresar →"}
          </button>
        </div>
      </div>
    </div>
  );
 
  // PANEL
  return (
    <div style={{ minHeight: "100vh", background: C.bg, fontFamily: "'Segoe UI', sans-serif" }}>
      {selected && <PerfilModal candidato={selected} onClose={() => setSelected(null)} />}
 
      <div style={{ background: C.white, borderBottom: `1px solid ${C.border}`, padding: "0 20px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: 9, background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 12 }}>JB</div>
          <div style={{ fontWeight: 800, fontSize: 15, color: C.text }}>Panel Admin</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ background: C.primaryLight, borderRadius: 20, padding: "4px 12px", fontSize: 12, color: C.primary, fontWeight: 700 }}>
            {candidatos.length} candidatos
          </div>
          <button onClick={() => setToken(null)} style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 8, padding: "5px 12px", color: C.textMuted, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>
            Salir
          </button>
        </div>
      </div>
 
      <div style={{ padding: "20px 16px", maxWidth: 700, margin: "0 auto" }}>
        <input
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          placeholder="🔍 Buscar por nombre, email o nivel..."
          style={{ width: "100%", background: C.white, border: `1px solid ${C.border}`, borderRadius: 12, padding: "11px 16px", color: C.text, fontSize: 14, outline: "none", fontFamily: "inherit", boxSizing: "border-box", marginBottom: 16 }}
        />
 
        {loadingData && (
          <div style={{ textAlign: "center", color: C.primary, fontSize: 14, padding: 40 }}>⏳ Cargando candidatos...</div>
        )}
 
        {!loadingData && filtrados.length === 0 && (
          <div style={{ textAlign: "center", color: C.textMuted, fontSize: 14, padding: 40 }}>
            {candidatos.length === 0 ? "Aún no hay candidatos registrados." : "No hay resultados para esa búsqueda."}
          </div>
        )}
 
        {filtrados.map(c => (
          <div
            key={c.id}
            onClick={() => setSelected(c)}
            style={{
              background: C.white, border: `1px solid ${C.border}`, borderRadius: 16,
              padding: "14px 16px", marginBottom: 10, cursor: "pointer",
              display: "flex", alignItems: "center", gap: 14, transition: "all 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = C.primary; e.currentTarget.style.boxShadow = "0 4px 12px rgba(232,93,38,0.1)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.boxShadow = "none"; }}
          >
            <div style={{ width: 42, height: 42, borderRadius: 12, background: C.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0, fontWeight: 800, color: C.primary }}>
              {c.nombre?.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: C.text }}>{c.nombre}</div>
              <div style={{ color: C.textMuted, fontSize: 12, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.email}</div>
            </div>
            <div style={{ flexShrink: 0 }}>
              <ScoreBadge score={c.score || 0} />
            </div>
            <span style={{ color: C.primary, fontSize: 18, flexShrink: 0 }}>›</span>
          </div>
        ))}
      </div>
    </div>
  );
}
 
